import {
  Box,
  Switch,
  Tag,
  IconButton,
  HStack,
  Text,
} from "@chakra-ui/react";
import { Pencil, Trash2 } from "lucide-react";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";

import {
  setIsEditing,
  setSubscription,
  updateSubscription,
} from "../../../../store/actions/subscriptionsActions";
import {
  updateDeleteModal,
  updateDrawer,
} from "../../../../store/actions/miscAction";
import {
  getSubscriptionReportName,
  isSubscriptionActive,
} from "../subscriptionInsights";

const SubscriptionRow = ({ subscription, index, reportTypes = [] }) => {
  const dispatch = useDispatch();

  const { reportRange, reports = [], id, subscriptionName } = subscription;

  const reportNames = reports.map((report) => getSubscriptionReportName(report, reportTypes));
  const updateSubscriptionStatus = () => {
    //update subscription status
    dispatch(
      updateSubscription(
        { activeStatus: isSubscriptionActive(subscription) ? 0 : 1 },
        id
      )
    );
  };

  return (
    <Box className="subscriptionCard">
      <Box className="subscriptionCardMain">
        <Box>
          <Text className="subscriptionCardEyebrow">Subscription {index + 1}</Text>
          <Text className="subscriptionCardTitle">{subscriptionName}</Text>
          <HStack className="subscriptionCardMeta">
            <Text>{reportRange}</Text>
            <Text>{reports.length} report{reports.length === 1 ? "" : "s"}</Text>
            <Text>{isSubscriptionActive(subscription) ? "Active" : "Paused"}</Text>
          </HStack>
        </Box>
        <HStack className="subscriptionCardActions">
          <Switch.Root
            size="md"
            checked={isSubscriptionActive(subscription)}
            onCheckedChange={updateSubscriptionStatus}
          >
            <Switch.HiddenInput id={`${id}-checkbox`} />
            <Switch.Control>
              <Switch.Thumb />
            </Switch.Control>
          </Switch.Root>
          <IconButton
            aria-label={`Edit ${subscriptionName}`}
            size="sm"
            variant="ghost"
            onClick={() => {
              dispatch(setSubscription(subscription));
              const drawer = {
                title: "Edit Reports Subscription",
                isOpen: 1,
                content: { id, component: "SubscriptionForm" },
              };
              dispatch(setIsEditing(true));
              dispatch(updateDrawer(drawer));
            }}
          >
            <Pencil size={16} />
          </IconButton>
          <IconButton
            aria-label={`Delete ${subscriptionName}`}
            size="sm"
            variant="ghost"
            onClick={() => {
              dispatch(updateDeleteModal({ isOpen: 1, subscriptionId: id }));
            }}
          >
            <Trash2 size={16} />
          </IconButton>
        </HStack>
      </Box>
      <Box className="subscriptionCardReports">
        <Text>Reports in this subscription</Text>
        <Box>
          {reportNames.map((reportName, index) => {
            return (
              <Tag.Root m={1} key={index}>
                <Tag.Label>{reportName}</Tag.Label>
              </Tag.Root>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};
const SubscriptionsTable = ({ subscriptions }) => {
  const { reportTypes } = useSelector((store) => store.defaultReducer);
  const reportTypesClone = _.cloneDeep(reportTypes);
  return (
    <Box className="subscriptionsList">
      {subscriptions.map((subscription, index) => {
        return (
          <SubscriptionRow
            subscription={subscription}
            index={index}
            reportTypes={reportTypesClone}
            key={subscription.id || index}
          />
        );
      })}
    </Box>
  );
};

export default SubscriptionsTable;
